// DateFilter.tsx
import React from 'react';
import { Grid, Button, Icon, TextField } from '@material-ui/core';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { ptBR } from 'date-fns/locale';

type DateFilterProps = {
    label: string | undefined | null;
    value: string | undefined | null;
    multiline?: boolean;
    minRows?: number;
};

const ModelField: React.FC<DateFilterProps> = ({ label, value, multiline, minRows }) => {
    return (
        <TextField
            label={label}
            fullWidth
            value={value}
            variant="outlined"
            disabled
            multiline={multiline}
            minRows={minRows}
            maxRows={5}
            InputProps={{
                style: { color: '#000' },
            }}
            InputLabelProps={{ style: { color: '#000' }, shrink: true }}
        />
    );
};

export default ModelField;
